// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-list[data-v-0e9f1e89] {
  width: 100%;
}
.user-list__filters[data-v-0e9f1e89], .user-list__list[data-v-0e9f1e89] {
  margin: 0 16px 24px;
}`, "",{"version":3,"sources":["webpack://./src/assets/js/pages/Address/AddressList.vue","webpack://./AddressList.vue"],"names":[],"mappings":"AAEA;EACE,WAAA;ACDF;ADGE;EAEE,mBAAA;ACFJ","sourcesContent":["@import \"./src/assets/sass/_vars.scss\";\n\n.user-list {\n  width: 100%;\n\n  &__filters,\n  &__list {\n    margin: 0 $space-md $space-lg;\n  }\n}\n",".user-list {\n  width: 100%;\n}\n.user-list__filters, .user-list__list {\n  margin: 0 16px 24px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
